var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 757,
    height: 708,
    viewBox: "0 0 757 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M378.5 708L144.128 406.815L0.479923 53.25L378.5 0.869972L756.52 53.2499L612.872 406.815L378.5 708Z",
    fill: "#58A0FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape8);
export default __webpack_public_path__ + "static/media/shape8.4935ca732f6f7f66288f20518d835d32.svg";
export { ForwardRef as ReactComponent };